<template>
    <div class="index-main">
        <header-bar tab-index="1"/>

        <div class="product-container">
            <div class="mes-header">
                <img src="../../resource/img/header.jpg"/>
                <div class="mes-title">产品中心</div>
            </div>

            <div class="product-body">
                <div class="product-item">
                    <img src="../../resource/img/product/menu/1.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">机加工mes系统</div>
                        <div class="item-content">机加工包含粗加工、精加工环节，又会细分为车、镗、铣、磨等很多细分工序，每个工序之间又穿插很多检测项，如超声检测、硬度检测、尺寸检测等，每个检测项又包含很多细分检测参数。一套机加工mes系统应该充分适配车间实际情况。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/2.jpg" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">铸造mes系统</div>
                        <div class="item-content">铸造mes系统从称重设备、液相分析、光谱分析、测温装置等各类硬件接口上采集数据，完成分析、计算、控制等动作。从而达成一个完整铸造控制、模具管理、分析监测流程。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/3.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">热处理mes系统</div>
                        <div class="item-content">热处理mes系统对接设备和测温设备，从现场获取第一手运行工艺数据，实时掌握系统运行情况，及时采取调度措施，使热处理设备、能耗设备尽可能运行在最佳状态，减少能耗。计算机结合波、谷、峰时间段，合理排产调度。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/4.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">工业数据采集系统</div>
                        <div class="item-content">工业互联网的发展离不开工业数据的应用，而工业数据的采集正是应用的基础。聚焦智能设备，为制造企业提供设备的物理信息、生产过程信息和设备故障信息等数据的采集和分析。旨在为制造企业提供实时、精准、标准化数据的同时，赋能生产过程可视化、实现车间透明化，提升生产效率。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/5.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">全流程质量追溯管理</div>
                        <div class="item-content">全流程应用数字化质量管理体系，随检随传质检数据，实时呈现质检报告，根源发现质量问题，及时预防质量事故。从根源向质量问题说再见！</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/6.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">仓储物流管理系统</div>
                        <div class="item-content">仓储物流管理系统可以应用于销售发货、原材料采购入库，自动采集磅秤数据，和ERP系统中的采购订单发货订单精确对接，对于成本核算、财务数据衔接有极大的帮助。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/7.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">设备管理系统</div>
                        <div class="item-content">设备是工厂生产的核心要素之一，设备的运行状态直接影响到生产效率，高效的设备管理可以减少故障和停机时间，提高设备利用率，有利于工厂的成本控制。设备管理系统能为工厂提供完整的设备管理解决方案，实现设备运行状态实时监测，提高设备运行效率，降低维护成本，并保障设备安全。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/8.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">车间报工系统</div>
                        <div class="item-content">车间报工系统，实现以人为核心的数字化车间管理。报工数据线上化，实时共享，实现执行力与人员绩效的高度统一，节省计件核算人员的人力成本。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-item">
                    <img src="../../resource/img/product/menu/9.png" style="height: 100%;" />
                    <div class="item-body">
                        <div class="item-title">电子看板</div>
                        <div class="item-content">电子看板系统是一套集液晶显示和智能数据采集于一体的生产管理看板系统，该系统将生产车间的生产进度、生产效率、设备状况等信息实时反馈在液晶屏幕上，使得管理者第一时间掌握生产信息，及时处理异常，进而提高生产效率。</div>
                        <div class="item-footer">
                            <div class="item-btn">
                                更多<i class="fa fa-caret-right" style="margin-left: 5px;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <side-bar/>
        <footer-bar/>
    </div>
</template>

<script>
import HeaderBar from '../../components/header';
import FooterBar from '../../components/footer';
import SideBar from '../../components/sider';
import '../../resource/css/common.css';

export default {
    name: "product",
    components: {
        'header-bar': HeaderBar,
        'footer-bar': FooterBar,
        'side-bar': SideBar,
    }
}
</script>

<style scoped>
.product-body {
    padding: 30px;
}

.product-item {
    width: 80vw;
    height: 320px;
    box-shadow: 0 0 15px #a4a4a4;
    margin: 30px auto;
    display: flex;
}

.product-item img {
    width: 420px;
}

.item-body {
    flex: 1;
    padding: 40px;
    display: flex;
    flex-direction: column;
}

.item-title {
    font-size: 22px;
    color: #000;
    font-weight: bold;
}

.item-content {
    margin-top: 30px;
    font-size: 18px;
    color: #1c1b1b;
    flex: 1;
}

.item-footer {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
}

.item-btn {
    font-size: 18px;
    color: #0171cb;
    cursor: pointer;
}

.item-btn:hover {
    color: #0e90f8;
}
</style>
